module.exports = __webpack_public_path__ + "img/team-availability.323f011a.png";